import { Injectable } from '@angular/core';

export interface ContractSignatureDraft {
  termsUser: boolean;
  signature: string | null;
}

export type ContractSignatureAttachmentDraftType = 'attachment-one' | 'attachment-two';

@Injectable({
  providedIn: 'root'
})
export class ContractSignatureDraftService {
  private readonly storageKeyPrefix = 'contractSignatureDraft';
  private readonly draftMaxAgeMs = 30 * 60 * 1000;

  saveDraft(draftKey: string, draft: ContractSignatureDraft): void {
    if (!draftKey) {
      return;
    }

    if (!draft.termsUser && !draft.signature) {
      this.clearDraft(draftKey);
      return;
    }

    try {
      sessionStorage.setItem(this.buildStorageKey(draftKey), JSON.stringify({
        ...draft,
        updatedAt: Date.now()
      }));
    } catch {
      // sessionStorage unavailable; silently ignore
    }
  }

  restoreDraft(draftKey: string): ContractSignatureDraft | null {
    if (!draftKey) {
      return null;
    }

    try {
      const raw = sessionStorage.getItem(this.buildStorageKey(draftKey));
      if (!raw) {
        return null;
      }

      const draft = JSON.parse(raw) as ContractSignatureDraft & { updatedAt?: number };
      if (!draft.updatedAt || Date.now() - draft.updatedAt > this.draftMaxAgeMs) {
        this.clearDraft(draftKey);
        return null;
      }

      return {
        termsUser: !!draft.termsUser,
        signature: draft.signature || null
      };
    } catch {
      return null;
    }
  }

  clearDraft(draftKey: string): void {
    if (!draftKey) {
      return;
    }

    try {
      sessionStorage.removeItem(this.buildStorageKey(draftKey));
    } catch {
      // sessionStorage unavailable; silently ignore
    }
  }

  buildAttachmentDraftKey(attachmentType: ContractSignatureAttachmentDraftType, saleChannel: string, vin: string): string {
    return `contract-summary-${attachmentType}:${saleChannel}:${vin || ''}`;
  }

  private buildStorageKey(draftKey: string): string {
    return `${this.storageKeyPrefix}:${draftKey}`;
  }
}